import { Link } from "@remix-run/react";
import { reactionTypes } from '#app/components/ui/reactions.js'
import { prettyDateShort } from "#app/utils/dateFormat.js";
import { truncateText } from "#app/utils/misc.tsx";


const categories = [
	{
		name: "General",
		slug: "general",
		img: "/images/meta-data/dex-bot-tamer.png"
	},
	{
		name: "PvP",
		slug: "pvp",
		img: "/images/meta-data/dex-bot-tamer.png"
	},
	{
		name: "PvE",
		slug: "pve",
		img: "/images/meta-data/dex-bot-tamer.png"
	},
	{
		name: "Crafting",
		slug: "crafting",
		img: "/images/meta-data/dex-bot-tamer.png"
	},
	{
		name: "Gathering",
		slug: "gathering",
		img: "/images/meta-data/dex-bot-tamer.png"
	},
	{
		name: "Roleplay",
		slug: "roleplay",
		img: "/images/meta-data/dex-bot-tamer.png"
	},
	{
		name: "Misc",
		slug: "misc",
		img: "/images/meta-data/dex-bot-tamer.png"
	},
	{
		name: "Dexxer",
		slug: "dex",
		img: "/images/meta-data/dex-bot-tamer.png"
	}
]

export const getCategoryBySlug = (slug: string) => {
	return categories.find(cat => cat.slug === slug)
}

export const categoryDisplay = (slug: string | null) => {
	if (!slug) return <></>
	// var cat = getCategoryBySlug(slug)
	// if (cat)	
	// 	return (
	// 		<div className="flex items-center">
	// 			<img src={cat.img} className="w-28 h-28 mr-2" />
	// 			<span>{cat.name}</span>
	// 		</div>
	// 	)

	return <div className="flex items-center">
		<span>Category: {slug}</span>
	</div>
}

export type ScriptLayoutType = {
	slug: string
	title: string
	category: string | null
	updatedAt: string | Date
	creator?: { username: string } | null
	description: string
	server: string
	reactions?: {
		type: string
		count: number
	}[]
	className?: string
}

export default function ScriptGrid({slug, title, category, updatedAt, className, creator, description, server, reactions}: ScriptLayoutType) {
	return <Link
		key={`script_grid_${slug}`}
		to={`/script/${slug}`}
		className="flex flex-col p-4 rounded-lg bg-background hover:bg-muted transition-colors"
	>
		<h3 className="text-lg font-semibold">{title}</h3>
		<div className="mt-4 flex items-center justify-between">
			<span className="text-sm">By {creator?.username || 'Anonymous'}</span>
			<span className="text-sm text-muted-foreground">{prettyDateShort(updatedAt)}</span>
		</div>
		<p className="text-sm text-muted-foreground mt-2">{truncateText(description, 100)}</p>
		<div className="my-4 flex flex-row gap-2">
			{server && (
				<span className="text-xs bg-primary/10 text-primary px-2 py-1 rounded">
					{server}
				</span>
			)}
			{category && (
				<span className="text-xs bg-primary/10 text-primary px-2 py-1 rounded">
					{category}
				</span>
			)}
		</div>
		{reactions && reactions.length > 0 && (
			<div className="mt-2 flex gap-2">
				{reactions.map(reaction => {
					const reactionType = reactionTypes.find(rt => rt.type === reaction.type);
					return reactionType ? (
						<span 
							key={reaction.type}
							className="text-xs bg-muted px-2 py-1 rounded flex items-center gap-1"
							title={`${reactionType.label}: ${reaction.count}`}
						>
							{reactionType.icon} {reaction.count}
						</span>
					) : null;
				})}
			</div>
		)}
	</Link>
}